export const config = {
  EMAIL_API: process.env.REACT_APP_EMAIL_API,
  IFRAME_ORIGIN: process.env.REACT_APP_IFRAME_ORIGIN,
  WORDPRESS_API: process.env.REACT_APP_WORDPRESS_API,
  css: {
    defaultFontFamily: "'NeueHaasGroteskText Pro', sans-serif",
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    fontWeightHeading: 500,
  }
}
